import React, { useEffect } from "react";

import { Modal, Typography, Input, Button, Loading } from "../../../core";
import { MixStyle } from "../../../styles";
import { Form } from "antd";
import styled from "styled-components";
import { updateCompany } from "../../../helper/utils/api/company";
const Notify_Utils = require("../../../helper/utils/Notification");

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const Section = styled.section`
  label {
    ${MixStyle.Label}
  }
`;

const EditCompany = ({
  modalState,
  companyData,
  getCompanyData,
  closeModal,
}) => {
  const [form] = Form.useForm();

  const [formInitialValue, setFormInitialValue] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);

  useEffect(() => {
    console.log("useeFFECT RUNINS");
    setFormInitialValue(companyData);
  }, [companyData]);

  const onFinish = async (fieldsValue) => {
    setIsLoading(true);
    try {
      const companyIdToEdit = formInitialValue._id;
      const response = await updateCompany(companyIdToEdit, fieldsValue);
      Notify_Utils.openNotificationWithIcon(
        "success",
        response.data.message || "Company updated successfully"
      );
      closeModal();
      getCompanyData();
    } catch (error) {
      const message =
        error?.response?.data?.message || "Error while updating company";
      Notify_Utils.openNotificationWithIcon("error", message);
    }
    setIsLoading(false);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Modal
      closable={true}
      visible={modalState}
      destroyOnClose={true}
      okText="Add"
      maxwidth="568px"
      footer={false}
      onCancel={closeModal}
      tittle="Edit Company"
    >
      {isLoading ? <Loading /> : null}
      <Section>
        {/* <div>{isLoading ? <Loading /> : ""}</div> */}
        <Form
          form={form}
          {...layout}
          name="basic"
          initialValues={formInitialValue}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label="Company Name"
            name="companyName"
            rules={[
              {
                required: true,
                message: "Please input Company Name!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Company Email"
            name="companyEmail"
            rules={[
              {
                required: true,
                message: "Please input Company Email!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="NTN"
            name="NTN"
            rules={[
              {
                required: true,
                message: "Please input NTN!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="STRN"
            name="STRN"
            rules={[
              {
                required: true,
                message: "Please input STRN!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Phone Number"
            name="phoneNumber"
            rules={[
              {
                required: true,
                message: "Please input Phone Number!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Company Address"
            name="companyAddress"
            rules={[
              {
                required: true,
                message: "Please input Address!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item>
            <Button width="187px" bg="#404E67" type="primary" htmlType="submit">
              <Typography
                text="Update Company"
                as="h5"
                noMargin
                weight="bold"
                align="center"
                color="white"
              />
            </Button>
          </Form.Item>
        </Form>
      </Section>
    </Modal>
  );
};

export default EditCompany;
